import { useState, useMemo } from 'react';

import { UserBorrowItem } from '../ui';

export const usePagination = (items: UserBorrowItem[], step = 9) => {
    const [page, setPage] = useState(0);

    const totalPages = useMemo(() => Math.ceil(items.length / step), [items.length, step]);

    return { page, setPage, totalPages };
};
